module.exports = function (game_self) {
  var players = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var help = "The Diet of Worms convenes as Protestant influence spreads across Germany...";
  var html = "\n      <div class=\"diet-overlay\" id=\"diet-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"cardfans\">\n          <div class=\"protestant\">\n\t  </div>\n\t  <div class=\"catholic\">\n\t  </div>\n\t</div>\n      </div>\n  ");
  return html;
};